import type { MRT_ColumnDef } from "mantine-react-table";
import type { ChatVectorIndexShorthand } from "src/db";
import type { AnyMetadataDocument } from "../types";

import { adsColumns } from "./adsColumns";
import { drawingsColumns } from "./drawingsColumns";
import { fsrColumns } from "./fsrColumns";
import { icmColumns } from "./icmColumns";
import { maintenanceManualsColumns } from "./maintenanceManualsColumns";
import { mgtFaultReportsColumns } from "./mgtFaultReportsColumns";
import { mindmapsColumns } from "./mindmapsColumns";
import { pdcColumns } from "./pdcColumns";
import { pdcFailedSensorColumns } from "./pdcFailedSensorColumns";
import { rdsColumns } from "./rdsColumns";
import { salesforceColumns } from "./salesforceColumns";
import { salesorderColumns } from "./salesorderColumns";
import { stgGlobalKnowledgeColumns } from "./stgGlobalKnowledgeColumns";
import { usefulInfoDocumentColumns } from "./usefulInfoColumns";
export const columnsMap: Partial<
    Record<ChatVectorIndexShorthand, MRT_ColumnDef<AnyMetadataDocument>[]>
> = {
    // biome-ignore lint/suspicious/noExplicitAny: TODO: This is a temporary fix to enforce TS typing.
    fsr: fsrColumns as any,

    // biome-ignore lint/suspicious/noExplicitAny: TODO: This is a temporary fix to enforce TS typing.
    sf: salesforceColumns as any,

    // biome-ignore lint/suspicious/noExplicitAny: TODO: This is a temporary fix to enforce TS typing.
    drawings: drawingsColumns as any,

    // biome-ignore lint/suspicious/noExplicitAny: TODO: This is a temporary fix to enforce TS typing.
    mindmaps: mindmapsColumns as any,

    // biome-ignore lint/suspicious/noExplicitAny: TODO: This is a temporary fix to enforce TS typing.
    rds: rdsColumns as any,

    // biome-ignore lint/suspicious/noExplicitAny: TODO: This is a temporary fix to enforce TS typing.
    pdc_reports: pdcColumns as any,

    // biome-ignore lint/suspicious/noExplicitAny: TODO: This is a temporary fix to enforce TS typing.
    pdc_failed_sensor_reports: pdcFailedSensorColumns as any,

    // biome-ignore lint/suspicious/noExplicitAny: TODO: This is a temporary fix to enforce TS typing.
    uinfo: usefulInfoDocumentColumns as any,

    // biome-ignore lint/suspicious/noExplicitAny: TODO: This is a temporary fix to enforce TS typing.
    ads_good_solutions: adsColumns as any,

    // biome-ignore lint/suspicious/noExplicitAny: TODO: This is a temporary fix to enforce TS typing.
    salesorders: salesorderColumns as any,

    // biome-ignore lint/suspicious/noExplicitAny: TODO: This is a temporary fix to enforce TS typing.
    icm: icmColumns as any,

    // biome-ignore lint/suspicious/noExplicitAny: TODO: This is a temporary fix to enforce TS typing.
    maintenance_manuals: maintenanceManualsColumns as any,

    // biome-ignore lint/suspicious/noExplicitAny: TODO: This is a temporary fix to enforce TS typing.
    stg_global_knowledge: stgGlobalKnowledgeColumns as any,

    // biome-ignore lint/suspicious/noExplicitAny: TODO: This is a temporary fix to enforce TS typing.
    mgt_fault_reports: mgtFaultReportsColumns as any,
};

// Re-export all column definitions for convenience
export {
    adsColumns,
    drawingsColumns,
    fsrColumns,
    icmColumns,
    maintenanceManualsColumns,
    mindmapsColumns,
    pdcColumns,
    pdcFailedSensorColumns,
    rdsColumns,
    salesforceColumns,
    salesorderColumns,
    stgGlobalKnowledgeColumns,
    usefulInfoDocumentColumns,
    mgtFaultReportsColumns,
};
